import { apiClient, fastApiClient } from "../App";

// ================= Auth =================

// Current logged-in user (GET /api/auth/me)
export const getMe = () => {
  return apiClient.get("/auth/me");
};

// Update profile (only name + department)  PATCH /api/users/<id>
export const updateUser = (id, data) => {
  return apiClient.patch(`/users/${id}`, data);
};

// Change password (POST /api/users/change-password/)
export const changePassword = (data) => {
  return apiClient.post("/change-password/", data);
};

// ================= SMTP =================

// Get All SMTP Configs
export const getSmtpConfigs = () => {
  return apiClient.get("/smtp-configs/");
};

// Add SMTP Config
export const addSmtpConfig = (data) => {
  return apiClient.post("/smtp-configs/", data);
};

// Update SMTP Config
export const updateSmtpConfig = (id, data) => {
  return apiClient.put(`/smtp-configs/${id}/`, data);
};

// Delete SMTP Config
export const deleteSmtpConfig = (id) => {
  return apiClient.delete(`/smtp-configs/${id}/`);
};

// Test SMTP Connection
export const testSmtpConnection = (id) => {
  return fastApiClient.post(`/smtp-configs/${id}/test`);
};

// Send SMTP Test Email
export const sendSmtpTestEmail = (id, email) => {
  return fastApiClient.post(
    `/smtp-configs/${id}/send-test?to_email=${encodeURIComponent(email)}`
  );
};

// ================= Twilio =================

// Get All Twilio Configs
export const getTwilioConfigs = () => {
  return apiClient.get("/twilio-configs/");
};

// Add Twilio Config
export const addTwilioConfig = (data) => {
  return apiClient.post("/twilio-configs/", data);
};

// Update Twilio Config
export const updateTwilioConfig = (id, data) => {
  return apiClient.put(`/twilio-configs/${id}/`, data);
};

// Delete Twilio Config
export const deleteTwilioConfig = (id) => {
  return apiClient.delete(`/twilio-configs/${id}/`);
};

// Test Twilio Connection
export const testTwilioConnection = (id) => {
  return fastApiClient.post(`/twilio-configs/${id}/test`);
};

// Send Test SMS / WhatsApp
export const sendTwilioTestMessage = (
  configId,
  to,
  channel,
  body
) => {
  return apiClient.post(
    `/twilio-configs/${configId}/send-test/`,
    null,
    {
      params: {
        to,
        channel,
        body,
      },
    }
  );
};

// ================= Voice Studio =================

// Get All Voices
export const getVoices = () => {
  return apiClient.get("/voices");
};

// Clone Voice
export const cloneVoice = (formData) => {
  return apiClient.post("/voices/clone", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};